<app-table title="{{'admin.lines.table.title' | translate}}"
           [data]="lines"
           [config]="tableConfig"
           [isLoading]="isLoading"
           [rowExpand]="false"
           [rowDuplicate]="true"
           [isMaterial]="false"
           [hasTitle]="hasTitle"
           [headerBackgroundColor]="headerBackgroundColor"
           (sortChange)="onSortChange($event)"
           (filterChange)="onFilterChange($event)"
           (pageChange)="onPageChange($event)"
           (duplicateClick)="onDuplicateRow($event)"
           (rowClick)="onRowClick($event)">
    <app-table-column header="{{'admin.lines.table.columns.lineId' | translate}}"
                      field="id">
    </app-table-column>
    <app-table-column header="{{'admin.lines.table.columns.lineName' | translate}}"
                      filter="true"
                      filterPlaceholder="{{'admin.lines.table.filter.placeholder.name' | translate}}"
                      sortable="true"
                      field="name">
    </app-table-column>
</app-table>
